import { Component } from '@angular/core'

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  standalone: false
})
export class PlansComponent {}
